function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 71c0-16 13-28 28-28h160c16 0 34 12 39 26l19 46c5 14-3 26-18 26H28c-15 0-28-13-28-28zm28 31h456c15 0 28 12 28 28v298c0 15-13 28-28 28H28c-15 0-28-13-28-28V130c0-16 13-28 28-28z"
}));